export const DO_POST_MESSAGE = `app/containers/SlackApplicationauthorization/DO_POST_MESSAGE`
export const DO_POST_MESSAGE_SUCCESS = `app/containers/SlackApplicationauthorization/DO_POST_MESSAGE_SUCCESS`
export const DO_POST_MESSAGE_ERROR = `app/containers/SlackApplicationauthorization/DO_POST_MESSAGE_ERROR`
